import React from "react";
import {
  FaTooth,
  FaShieldAlt,
  FaTeethOpen,
  FaMagic,
  FaSmileBeam,
  FaHeartbeat,
} from "react-icons/fa";

const services = [
  {
    icon: <FaShieldAlt />,
    title: "Preventive Dentistry",
    text: "Routine cleanings, exams, and preventive care that keep future dental problems from ever starting.",
  },
  {
    icon: <FaTooth />,
    title: "Fillings & Restorations",
    text: "Tooth-colored fillings and restorations that repair decay while preserving your natural smile.",
  },
  {
    icon: <FaHeartbeat />,
    title: "Root Canal Therapy",
    text: "Gentle, modern root canal treatment to relieve pain and save your natural teeth.",
  },
  {
    icon: <FaTeethOpen />,
    title: "Extractions & Oral Surgery",
    text: "Comfortable extractions and minor oral surgery with a focus on a smooth recovery.",
  },
  {
    icon: <FaSmileBeam />,
    title: "Cosmetic Dentistry",
    text: "Teeth whitening, porcelain veneers, and cosmetic bonding to bring out your best smile.",
  },
  {
    icon: <FaMagic />,
    title: "Crowns, Bridges & Implants",
    text: "Natural-looking crowns, bridges, and dental implants that restore both function and confidence.",
  },
];

const DentalServices = () => {
  return (
    <div>
      <span className="eyebrow">What We Offer</span>
      <h1>Dental Services</h1>
      <p className="lead">
        Our treatment philosophy is geared toward preventing future dental
        problems. We care for teens and adults and offer a broad range of
        treatment, from the most basic to the state of the art.
      </p>

      <div className="feature-grid">
        {services.map((s) => (
          <div className="info-card" key={s.title}>
            <span className="info-card__icon">{s.icon}</span>
            <h3>{s.title}</h3>
            <p>{s.text}</p>
          </div>
        ))}
      </div>

      <div className="services-detail">
        <h2>Bringing Out Your Best</h2>
        <p>
          Our primary goal is to help you achieve and maintain a healthy,
          beautiful smile. This is why we stay up to date with modern
          restorative dentistry practices that preserve your natural teeth.
        </p>
        <p>
          We understand the importance of providing these services in the most
          comfortable, stress-free manner. We strive to excel in the art of
          dental anesthesia, provide pain-free treatment, and offer nitrous
          oxide to relax patients who request it.
        </p>
      </div>
    </div>
  );
};

export default DentalServices;
